"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jump_js_1 = __importDefault(require("jump.js"));
exports.default = () => {
    const $items = document.querySelectorAll('.c-page-index li a[href^="#"], .entries__link[href^="#"]');
    for (let i = 0; i < $items.length; i++)
        $items[i].addEventListener('click', onClick, false);
    init();
};
/**
 * クリック時処理
 *
 * @param event MouseEvent
 */
const onClick = (event) => {
    event.preventDefault();
    const $el = event.currentTarget;
    const href = $el.getAttribute('href');
    if (href && /^#(.*)$/.test(href)) {
        const $target = document.querySelector(href);
        const offset = getOffset();
        if ($target)
            (0, jump_js_1.default)($target, { offset });
    }
};
/**
 * 画面読み込み時処理
 */
const init = () => {
    if (window.location.hash) {
        const $target = document.querySelector(window.location.hash);
        const offset = getOffset();
        if ($target)
            (0, jump_js_1.default)($target, { offset });
    }
};
const getOffset = () => {
    const Header = document.querySelector('.l-Navigation');
    const SpHeader = document.querySelector('.l-SpMenu');
    return (SpHeader && SpHeader.clientHeight > 0) ? SpHeader.clientHeight * -1 : (Header ? Header.clientHeight * -1 : 0);
};
